import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import licenseService from "core/services/metaStoreService/license-service";
import growl from "app/components/common/growl";
import APPS_ROUTES from "../apps/routes.json";

interface McpRouteGuardProps {
    children: React.ReactElement;
}

const McpRouteGuard: React.FC<McpRouteGuardProps> = ({ children }) => {
    const isMCPEnabled = licenseService?.isMCPEnabled;

    useEffect(() => {
        if (!isMCPEnabled) {
            growl.error("404 Error", "Oops, we can't seem to find the page you requested");
        }
    }, [isMCPEnabled]);

    if (!isMCPEnabled) {
        return <Navigate to={APPS_ROUTES.homepage} />;
    }

    return children;
};

export default McpRouteGuard;
